

<section id="seedMange" class="sec_seed">
  <div class="container mat-elevation-z8 py-3">
    <div class=" seed-container">
      <app-seed-table [data]="dataFOrSeed" title_page="Seed Keywords" (addSeed)="addSeed($event)" (addRemvSelectRow)="addRemoveAssignList($event)" (addRemvSelectRowArr)="addRemoveAssignListArr($event)" [reason]="noclientseed"></app-seed-table>
    </div>

    <div class=" title_con">
      <div class="holder_operatoin">
        <div>
          <mat-form-field appearance="fill">
            <mat-label>Select client</mat-label>
            <mat-select [(ngModel)]="clientSelected">
              <mat-option [value]="c.clientID" *ngFor="let c of clients">
                {{ c.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <button  mat-raised-button color="accent" (click)="assignSelected()" [disabled]="disableAssign()">Create</button>
        </div>
      </div>
    </div>
  </div>
</section>
<section id="seedCliMange" class="sec_seed">
  <div class="container mat-elevation-z8 py-3">
    <div class=" seed-container">
      <app-seed-table [data]="dataFOrClientSeed" [clients]="clients"  (addSeed)="addSeed($event)"  title_page="Client Specific Seed Keywords" [reason]="seed"></app-seed-table>
    </div>
  </div>
</section>

<section id="seedCreate" class="sec_seed">
  <div class="container mat-elevation-z8 py-3">
    <div>
      <h2 class="title">Create new seeds</h2>
    </div>
    <form [formGroup]="createseedForm" (ngSubmit)="createSeed()">
      <div class="third_row">
        <mat-radio-group formControlName="seedType" (change)="changeSeedtype($event)" aria-label="Select an Client">
          <mat-radio-button value="1">Default</mat-radio-button>
          <mat-radio-button value="2">Client Specific</mat-radio-button>
        </mat-radio-group>
        <mat-form-field appearance="standard" class="filter_inp_seed_key_tbl" *ngIf="createseedForm.value.seedType=='2'">
          <mat-label>Select client</mat-label>
          <mat-select formControlName="clientID" [disabled]="createseedForm.value.seedType=='1'">
            <mat-option *ngFor="let c of clients" [value]="c.clientID">{{c.name}}</mat-option>

          </mat-select>
        </mat-form-field>
      </div>
      <div class="mformROw">
        <div class="firstROw">

          <mat-form-field>
            <mat-label>Theme Name</mat-label>
            <mat-select id="selectTheme" formControlName="configAdGroupID">
              <mat-option *ngFor="let adg of adGroups" [value]="adg.id">{{adg.code}}</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="formCont">
            <mat-checkbox (change)="changeEventForChecks($event)" id="broadCpc" formControlName="isBroad">Broad</mat-checkbox>
            <mat-checkbox (change)="changeEventForChecks($event)"  formControlName="isPhrase" id="phraseCpc">Phrase</mat-checkbox>
            <mat-checkbox (change)="changeEventForChecks($event)" formControlName="isExact" id="exactCpc">Exact</mat-checkbox>
          </div>

        </div>
        <div class="sec_row">
          <mat-form-field>
            <mat-label>Seed Text</mat-label>
            <input matInput formControlName="seedText">
          </mat-form-field>
          <mat-form-field>
            <mat-label>Broad CPC</mat-label>
            <input type="number" onKeyPress="if(this.value.includes('.') && this.value.length==4) return false;"  min="0" step="0.01" matInput  formControlName="broadCpc">
          </mat-form-field>
          <mat-form-field>
            <mat-label>Phrase CPC</mat-label>
            <input type="number" onKeyPress="if(this.value.includes('.') && this.value.length==4) return false;"  min="0" step="0.01" matInput formControlName="phraseCpc">
          </mat-form-field>
          <mat-form-field>
            <mat-label>Exact CPC</mat-label>
            <input type="number" min="0" step="0.01" onKeyPress="if(this.value.includes('.') && this.value.length==4) return false;" maxlength="4" matInput formControlName="exactCpc">
          </mat-form-field>

        </div>


      </div>
      <div class="forthrow">
        <button type="submit" [disabled]="!createseedForm.valid" mat-raised-button color="primary">Create</button>

      </div>
    </form>
  </div>
</section>
